var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.typeInput,_vm._b({tag:"component",attrs:{"type":_vm.type},on:{"update:value":function($event){return _vm.$emit('update:value', $event)},"blur":function($event){return _vm.$emit('blur')}}},'component',_vm.inputProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }